export default __webpack_public_path__ + "611ac6a769e28bb4797bf94542253a12.png";